exports.ENDPOINT_URL = '/data/dashboard-statistics'
exports.TOTAL_WATER_USED = 'totalSoapyWaterUsed'
exports.ALTERNATIVE_TOTAL_WATER_USED = 'totalAlternativeWaterUsed'
exports.TOTAL_SOAP_USED = 'totalSoapySoapUsed'
exports.ALTERNATIVE_TOTAL_SOAP_USED = 'totalAlternativeSoapUsed'
